<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.ri_spec')"
    icon="res-billaccount"
    :res-name="detailData.spec || detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :spec="detailData.spec"
      :cloudaccount-id="cloudaccountId"
      :date-param="dateParam" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import RiCoverageSpecDetail from './Detail'

export default {
  name: 'RiCoverageSpecSidePage',
  components: {
    RiCoverageSpecDetail,
  },
  mixins: [WindowsMixin, SidePageMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('common_386'), key: 'ri-coverage-spec-detail' },
      ],
    }
  },
  computed: {
    cloudaccountId () {
      return this.params.cloudaccountId || this.detailData.cloudaccount_id || this.detailData.cloudaccountId
    },
    dateParam () {
      return this.params.dateParam || this.detailData.dateParam || {}
    },
  },
}
</script>
